export class Stat{
    timeStamp = Date.now();
    duration: number = 0;
    exerciseID: string;
    executionContextID: string;

    constructor(exerciseID?: string, executionContectID?: string){
        this.exerciseID = exerciseID
        this.executionContextID = executionContectID;
    }
}


// WEBPACK FOOTER //
// /codebuild/output/src1521087412/src/client/web-client/src/app/shared/models/Stat.ts